import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import {Box, Button, CardActionArea, CardActions, Chip, Tooltip} from '@mui/material';
import PropTypes from "prop-types";
import {useNavigate} from "react-router";
import EditIcon from '@mui/icons-material/Edit';
import CreateProductDialog from "../Admin/CreateProductDialog";
import { useState} from "react";

import {useSelector} from "react-redux";
import DeleteProductDialog from "./DeleteProductDialog";
import ProductPrice from "../Common/PriceComponent";
import ResponseDialog from "../ResponseDialog";
import SaleLabel from "./SaleLabel";
import LimitedLabel from "./LimitedLabel";

export default function ProductCard(props) {
    const [state, setState] = useState({
        isResponseDialogOpen: false,
        responseData: {
            isUpdate: false,
            responseData: {}
        },
        isEditProductDialog: false,
        isDeleteProductDialogOpen: false,
    })
    const navigate = useNavigate();
    const sessionState = useSelector((state) => state.data.UserSession);
    const userBalance = sessionState.usersDetails.balance
    let isNotEnoughBelcoins = props.product.isSale? userBalance < props.product.salePrice : userBalance < props.product.price;

    const handleOrderButton = () => {
        navigate('/products/' + props.product.id, {state: props.product})
    }
    //TODO rework to use a Link component
    const handleCardClick = () => {
        const product = JSON.parse(JSON.stringify(props.product));
        navigate('/products/' + product.id, {state: product})
    }
    const handleDeleteProduct = () => {
        setState({
            ...state,
            isDeleteProductDialogOpen: true
        })
    }
    const handleEditButton = () => {
        setState({
            ...state,
            isEditProductDialog: true,
        })
    }

    const handleClose = (responseData) => {
        setState({
            ...state,
            isResponseDialogOpen: responseData.isResponseReady,
            responseData: responseData.data,
            isEditProductDialog: false,
            isDeleteProductDialogOpen: false
        })
    };

    const handleResponseDialogClose = () => {
        setState({
            ...state,
            isResponseDialogOpen: false
        })
    }


    return (
        <Box sx={{p: 1}} className={"product-card"}>
            <Card>
                <CardActionArea>
                    {props.product && props.product.isSale &&
                        <SaleLabel
                            oldPrice={props.product.price}
                            newPrice={props.product.salePrice}
                        />
                    }
                    {props.product.isLimited &&
                        <LimitedLabel
                            labelClassName = {"product-card-limited"}
                            text={props.product.limitedText}
                        />
                    }
                    <Box style={{position:'relative'}}>
                        <CardMedia
                            className={"product-card__image"}
                            component="img"
                            src={props.product.images[0]}
                            image={props.product.images[0]}
                            alt={props.product.title}
                            onClick={handleCardClick}
                        />
                        <CardContent className={"product-card__content"}>
                            <Typography
                                component="div" className={"product-card__contentText"}>
                                {props.product.title}
                            </Typography>

                            {
                                props.isAdminMode ?
                                    <Box sx={{mb: 2}}>
                                        <Chip

                                            label="Delete"
                                            color="warning"
                                            onDelete={handleDeleteProduct}/>
                                        <Chip
                                            sx={{ml: 2}}
                                            label="Edit"
                                            color="primary"
                                            icon={<EditIcon/>}
                                            onClick={handleEditButton}
                                        >
                                        </Chip>
                                    </Box> :
                                    <Box sx={{display: 'flex', justifyContent: 'space-between',  alignItems: 'center'}}>
                                        { props.product.isSale ?
                                            <ProductPrice
                                                price={props.product.price}
                                                style={"strikeout-price"}
                                                salePrice={props.product.salePrice}
                                            />:
                                            <ProductPrice
                                                price={props.product.price}/>
                                        }
                                        {isNotEnoughBelcoins ?
                                            <Tooltip title="Not enough belcoins">
                                                <Button
                                                    sx={{ml: 2}}
                                                    size="small"
                                                    variant="outlined"
                                                    color="secondary"
                                                >
                                                    Order
                                                </Button>
                                            </Tooltip> :
                                            <Button
                                                sx={{ml: 2}}
                                                size="small"
                                                variant="outlined"
                                                color="warning"
                                                disabled={isNotEnoughBelcoins}
                                                onClick={handleOrderButton}
                                                title={isNotEnoughBelcoins ? "Not enough belcoins" : null}

                                            >
                                                {props.product.isCharity ? "Donate" : "Order"}
                                            </Button>
                                        }

                                    </Box>}
                        </CardContent>
                    </Box>
                </CardActionArea>
            </Card>
            <CreateProductDialog
                open={state.isEditProductDialog}
                onClose={handleClose}
                isEditMode={true}
                isCopyMode={false}
                product={props.product}
                refetchProduct={props.refetchProduct}
            />
            <DeleteProductDialog onClose={handleClose}
                                 open={state.isDeleteProductDialogOpen}
                                 productId={props.product.id}
                                 productName={props.product.title}
                                 refetchProduct={props.refetchProduct}
            />
            {state.responseData &&
                <ResponseDialog
                    onClose={handleResponseDialogClose}
                    open={state.isResponseDialogOpen}
                    responseData={state.responseData.responseData ? state.responseData.responseData : {}}
                    label={state.responseData.isUpdate ? "Edit product" : "Create product"}
                    refetch={props.refetchProduct}
                />
            }
        </Box>

    );
}
ProductCard.propTypes = {
    product: PropTypes.object.isRequired,
    isAdminMode: PropTypes.bool.isRequired,
    refetchProduct: PropTypes.func.isRequired,
};
